import * as yup from 'yup';

yup.addMethod(yup.string, 'equalToSibling', function equalToSibling(siblingKey, message) {
  return this.test(
    'equalToSibling',
    message || `should be equal to ${siblingKey}`,
    (value, context) => value === context.parent[siblingKey],
  );
});
